import { reportError, errorStep } from "./posthog.js";
import { initializeImageFormat } from "./image-format.js";
import { preferredLocale, translator } from "./i18n.js";
let saved = {};
try {
  saved = JSON.parse(localStorage.getItem("runmarco-reimagined-v1") || "{}");
} catch {}
const locale = preferredLocale(
  saved && typeof saved === "object" ? saved : {},
  navigator.language,
);
const t = translator(locale);
document.documentElement.lang = locale;
document.title = t("title");
document.getElementById("boot-message").textContent = t("loadingAdventure");
document
  .getElementById("boot-progress")
  .setAttribute("aria-label", t("loadingAdventure"));
// Choose image URLs before rendering markup or creating Phaser textures.
errorStep('bootstrap_started');
initializeImageFormat()
  .then(() => import("./main.js"))
  .catch((error) => {
    reportError(error, 'bootstrap');
    console.error(error);
    document.getElementById("boot-message").textContent = t("loadError");
  });
